<template>
  <div class="d-flex ellipsis align-items-baseline flex-wrap gap-10">
    <h3 class="section-title ellipsis">{{ organization.name }}</h3>
    <span class="time-zone">{{ organization.time_zone_name }}</span>
  </div>
</template>

<script>
export default {
  name: 'ReportHeaderOrganizationWithTimeZone',
  props: { organization: { type: Object, required: true } },
};
</script>
